import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/repairPaver/blog-fix-paver-001.jpg";
import { ViewPavers } from "../../../../CTA/CTA";

// SEO
// import SEO from "../../../../SEO/index.js";

export const RepairPaverData = {
  title: "How to Repair a Broken Driveway Paving Stone in 3 Steps",
  image: img001,
  destination: "/blog/repair-broken-driveway-paving-stone",
  date: "August 11, 2015",
  categories: ["blog", "paving-stones"],
};

const RepairPaver = () => {
  const blog = [RepairPaverData];

  return (
    <>
      {/* <SEO
        title="The Best Privacy Hedges for Southern California: 8 Plants to Know"
        description="Discover the seven best privacy hedges for Southern California homes and factors to take into consideration when planting hedges."
        profileURL={
          "https://www.pacificoutdoorliving.com/blog/best-privacy-hedges-southern-california-8-plants-know/"
        }
      /> */}
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              You’ve finally decided to switch to paving stones and couldn’t be
              happier about it. You just love coming home to an elegant-looking
              driveway. But a few months later, you notice a stone is broken.
              It’s no longer as perfect as it used to be.
            </p>

            <p>
              Paving stones are extremely durable and low maintenance. However,
              as with any other landscape projects, proper installation is
              crucial to ensure it delivers as you expected. With that said, be
              sure to work only with reputable paver installers. But don’t
              worry. While it’s unlikely to find broken paving stones, it only
              takes a few steps to remedy this eyesore. You can even do it
              yourself.
            </p>

            <p>
              Let’s walk you through the three steps of broken paving stone
              repair. The tools you’ll be needing for this project are a rubber
              mallet, screw drivers, and sand. You could also use a spirit
              level.
            </p>
            <h4>1. LOOSEN UP SAND JOINTS</h4>
            <p>
              Your goal is to remove the broken paving stone. In order to do
              that, you need to saturate the compacted sand that joins it with
              its neighboring stones. Compacted sand is almost as strong as
              concrete, but not permanent. This makes repair and replacing
              individual stones easy. To loosen up the sand, run water to the
              stones and into the joints using garden hose. Watch out though.
              You don’t want to waste water here. Two minutes should be enough.
            </p>
            <h4>2. REMOVE PAVING STONE</h4>
            <p>
              Once the sand has loosened up a bit, you can proceed to removing
              the stone. This part may take longer depending on the paving stone
              used. This also requires patience and attention to make sure the
              rest of other stones are not damaged in the process. Lift the
              stone out using screwdrivers. For a stubborn stone, you can use
              your rubber mallet to tap and loosen surrounding stones.
            </p>
            <h4>3. LAY NEW STONE</h4>
            <p>
              After removing the paver, it’s time to put a layer of sand base.
              Carefully push sand on the surface. You can use a spirit level to
              ensure even distribution. Once the sand base is ready, you can now
              put in the new paver. Using the rubber mallet, push it down until
              it’s leveled with the other paving stones. And then, fill the
              joints with sand. Afterward, smooth it out with a push broom. Once
              done, spray it water. Let it dry for a stronger hold. Once dry,
              sweep the area again to get rid of debris.
            </p>
            <h4>AND THAT’S IT!</h4>
            <p>Your driveway paving stones are looking as good as new again.</p>

            <p>
              Paving stones should be able to provide you years of enjoyment. If
              it fails, it’s likely due to poor workmanship. If you feel that
              the damage on your driveway is difficult to tackle on your own,
              don’t hesitate to get in touch with a trusted paver company near
              you. Working with paving stone installation professionals will
              help save you from another headache.
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(RepairPaver);
